

import { Paper, Table, TableContainer } from "@mui/material"





export const LayoutTabla = ({ children, paginado, mt=0, mb=0,  sx={} }) => {


    return (
        <Paper sx={{ width:'100%', overflowX:'auto', mt:mt, mb:mb, ...sx }}>
            <TableContainer>
                <Table sx={{ minWidth:900, tableLayout:"fixed" }}>
                    { children }
                </Table>

                { paginado && paginado }
                
            </TableContainer>
        </Paper>
    )
}
